import ConfirmationModal from 'components/Modals/Confirmation';
import { useMyOrderIntentionsContext } from 'contexts/MyOrderIntentionsContext';
import { OrderIntention } from 'model/OrderIntention';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import * as MyOrderIntentionEditCalls from 'store/state/myOrderIntentionEdit/apiCalls';
import { myOrderIntentionEditSelectors } from 'store/state/selectors';
import { myOrderIntentionEditActions } from 'store/state/slices';
import DetailsModal from '../DetailsModal';
import JustificationModal from '../JustificationModal';
import ObservationModal from '../ObservationModal';

interface Props {
  data: OrderIntention[] | undefined;
  observationText?: string;
  isObservationVisible?: boolean;
  onCloseObservation?: () => void;
}

export default function OrderIntentionModals({
  data,
  observationText,
  isObservationVisible,
  onCloseObservation,
}: Props) {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { setDataTable } = useMyOrderIntentionsContext();

  const showModalCancel = useSelector(
    myOrderIntentionEditSelectors.getShowModalCancel,
  );
  const idCancel = useSelector(myOrderIntentionEditSelectors.getIdCancel);
  const showModalRepublish = useSelector(
    myOrderIntentionEditSelectors.getShowModalRepublish,
  );
  const showModalNoRepublish = useSelector(
    myOrderIntentionEditSelectors.getShowModalNoRepublish,
  );
  const showModalNoJustification = useSelector(
    myOrderIntentionEditSelectors.getShowModalNoJustification,
  );
  const justificationText = useSelector(
    myOrderIntentionEditSelectors.getJustificationText,
  );
  const idRepublish = useSelector(myOrderIntentionEditSelectors.getIdRepublish);
  const showModalAprove = useSelector(
    myOrderIntentionEditSelectors.getShowModalAprove,
  );
  const showModalReprove = useSelector(
    myOrderIntentionEditSelectors.getShowModalReprove,
  );
  const idsBulkAprove = useSelector(
    myOrderIntentionEditSelectors.getIdsBulkAprove,
  );
  const idsBulkReprove = useSelector(
    myOrderIntentionEditSelectors.getIdsBulkReprove,
  );
  const idsJustification = useSelector(
    myOrderIntentionEditSelectors.getIdsJustification,
  );

  return (
    <>
      <DetailsModal />
      <JustificationModal
        onSubmit={(value) => {
          const addJustification = data?.map((item) => {
            if (idsJustification.includes(item.id)) {
              return {
                ...item,
                justification: value,
              };
            }
            return item;
          });
          setDataTable(addJustification);
        }}
      />
      {onCloseObservation && (
        <ObservationModal
          isVisible={Boolean(isObservationVisible)}
          observationText={observationText ?? ''}
          onCancel={onCloseObservation}
        />
      )}
      <ConfirmationModal
        modalIsVisible={showModalAprove}
        textTitle="Aprovar Venda Direta"
        textDescription="Tem certeza que deseja aprovar esse pedido?"
        textButtonOk="Sim, aprovar"
        textButtonCancel="Voltar"
        actionButtonOk={() => {
          dispatch(
            MyOrderIntentionEditCalls.aproveOrReproveDirectSale({
              approve: true,
              justification: null,
              ids: idsBulkAprove,
            }),
          );
          dispatch(myOrderIntentionEditActions.setShowModalAprove(false));
        }}
        actionButtonCancel={() =>
          dispatch(myOrderIntentionEditActions.setShowModalAprove(false))
        }
      />
      <ConfirmationModal
        modalIsVisible={showModalReprove}
        textTitle="Recusar Venda Direta"
        textDescription="Tem certeza que deseja recusar esse pedido?"
        textButtonOk="Sim, recusar"
        textButtonCancel="Voltar"
        actionButtonOk={() => {
          dispatch(
            MyOrderIntentionEditCalls.aproveOrReproveDirectSale({
              approve: false,
              justification: justificationText,
              ids: idsBulkReprove,
            }),
          );
          dispatch(myOrderIntentionEditActions.setShowModalReprove(false));
        }}
        actionButtonCancel={() =>
          dispatch(myOrderIntentionEditActions.setShowModalReprove(false))
        }
      />
      <ConfirmationModal
        modalIsVisible={showModalCancel}
        textTitle="Cancelar"
        textDescription="Tem certeza que deseja cancelar essa intenção de compra (IC)?"
        textButtonOk="Sim, cancelar IC"
        textButtonCancel="Voltar"
        actionButtonOk={() => {
          dispatch(MyOrderIntentionEditCalls.cancelBuyIntention(idCancel));
          dispatch(myOrderIntentionEditActions.setShowModalCancel(false));
        }}
        actionButtonCancel={() =>
          dispatch(myOrderIntentionEditActions.setShowModalCancel(false))
        }
      />
      <ConfirmationModal
        modalIsVisible={showModalRepublish}
        textTitle="Republicar"
        textDescription="Tem certeza que deseja republicar essa intenção de compra (IC)?"
        textButtonOk="Sim, republicar"
        textButtonCancel="Voltar"
        actionButtonOk={() => {
          dispatch(
            MyOrderIntentionEditCalls.republishBuyIntention(idRepublish),
          );
          dispatch(myOrderIntentionEditActions.setShowModalRepublish(false));
        }}
        actionButtonCancel={() =>
          dispatch(myOrderIntentionEditActions.setShowModalRepublish(false))
        }
      />

      <ConfirmationModal
        modalIsVisible={showModalNoRepublish}
        textTitle="Republicar"
        textDescription={t('myOrderIntentions.subtitleNoRepublish')}
        textButtonOk="Voltar"
        actionButtonOk={() => {
          dispatch(myOrderIntentionEditActions.setShowModalNoRepublish(false));
        }}
        widthModal={500}
      />

      <ConfirmationModal
        modalIsVisible={showModalNoJustification}
        textTitle="Aviso"
        textDescription="É necessário preencher uma justificativa para recusar."
        textButtonOk="Voltar"
        actionButtonOk={() => {
          dispatch(
            myOrderIntentionEditActions.setShowModalNoJustification(false),
          );
        }}
        widthModal={500}
      />
    </>
  );
}
